export const STATUS_CERTIFIED = 'CERTIFIED';
export const STATUS_NO_MATCH = 'NO_MATCH';
export const STATUS_NEUTRAL = 'NEUTRAL';
export const STATUS_MATCH = 'MATCH';
export const STATUS_CUSTOM = 'CUSTOM';
export const STATUSES = [
  STATUS_CERTIFIED,
  STATUS_MATCH,
  STATUS_NO_MATCH,
  STATUS_NEUTRAL,
  STATUS_CUSTOM,
];
